<button
    class="d-print-none"
    [attr.type]="buttonType()"
    [class.loading-button]="loading()"
    [class.w-100]="wide()"
    [disabled]="disabled() ? 'disabled' : null"
    [matButton]="type()"
    (click)="handlerClick.emit($event)">
    @if (label()) {
        {{ label() }}
    }
</button>
